import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Featured.vue'), // Featured Cocktails page
    },
    {
      path: '/all-cocktails',
      name: 'allCocktails',
      component: () => import('./views/Explore.vue'), // All Cocktails page
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/Search.vue'), // Combined Search Drinks page
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: () => import('./views/Favorites.vue'), // Saved Cocktails page
    },
    {
      path: '/recipe/:id',
      name: 'recipe',
      component: () => import('./views/Recipe.vue'),
    },    
    {
      path: '*',
      name: '404',
      component: () => import('./views/PageNotFound.vue'), // 404 page
    },
  ],
});
